import { render, staticRenderFns } from "./ContentView.vue?vue&type=template&id=16c6b207&scoped=true&"
import script from "./ContentView.vue?vue&type=script&lang=js&"
export * from "./ContentView.vue?vue&type=script&lang=js&"
import style0 from "./ContentView.vue?vue&type=style&index=0&id=16c6b207&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c6b207",
  null
  
)

export default component.exports